import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "driver-modal",
  class: "modal fade",
  id: "selectCarModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["onChange", "checked", "value", "id"]

import {useTemplateRef, computed} from "vue";
import BaseModal from "@/components/modals/BaseModal.vue";
import {IDriver} from "@/interfaces/IDriver";


export default /*@__PURE__*/_defineComponent({
  __name: 'DriversModal',
  props: {
    drivers: {},
    selected: {},
    filterName: {}
  },
  emits: ['toggleDrivers', 'filter:name'],
  setup(__props: any, { emit: __emit }) {

// eslint-disable-next-line no-unused-vars
const props = __props;

const emits = __emit;

const setDrivers = (e: any, id: number) => emits('toggleDrivers', {
  status: e.target.checked,
  id
});

const modal = useTemplateRef('driver-modal');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, null, {
    modal: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h1", {
                class: "modal-title fs-5",
                id: "exampleModalLabel"
              }, " Выбор водителя "),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, [
                _cache[1] || (_cache[1] = _createTextVNode(" Фильтр по ФИО ")),
                _createElementVNode("input", {
                  value: _ctx.filterName,
                  onInput: _cache[0] || (_cache[0] = e => emits('filter:name', e)),
                  type: "text",
                  class: "form-control form-control-sm"
                }, null, 40, _hoisted_6)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.drivers, (driver, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "form-check"
                }, [
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: driver.id
                  }, _toDisplayString(driver.name), 9, _hoisted_7),
                  _createElementVNode("input", {
                    onChange: (event) => setDrivers(event, driver.id),
                    checked: _ctx.selected.find(id => id === driver.id),
                    value: driver.id,
                    class: "form-check-input",
                    type: "radio",
                    name: "drivers",
                    id: driver.id
                  }, null, 40, _hoisted_8)
                ]))
              }), 128))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-footer" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, "Закрыть")
            ], -1))
          ])
        ])
      ], 512)
    ]),
    action: _withCtx(({open}) => [
      _renderSlot(_ctx.$slots, "action", {
        open: () => open(_unref(modal))
      })
    ]),
    _: 3
  }))
}
}

})